import { useState } from 'react';

const CHIPS = ['Quote was fine', 'Misidentified - item & price updated'];
export const REVIEW_ACTIONS = [
    { value: 'make_offer', label: 'Make offer' },
    { value: 'offer_consignment', label: 'Offer Consignment' },
    { value: 'reject', label: 'Reject' },
    { value: 'other', label: 'Other, see comment' },
];

// Reviewer's "Review done" hand-back: a suggested action for the admin who
// finalises, plus a mandatory comment. The quick-fill chips prefill the comment
// with common messages (spec docs/archive/202609/specs_20260916_quote_review.md).
export default function ReviewDoneDialog({ busy, onCancel, onConfirm }) {
    const [comment, setComment] = useState('');
    const [action, setAction] = useState('make_offer');
    const trimmed = comment.trim();

    return (
        <div className="modal-overlay">
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Review done</h2>
                    <button className="modal-close" onClick={onCancel}>&times;</button>
                </div>
                <div className="modal-body-scroll">
                    <div className="qa-field">
                        <label className="qa-field-label" htmlFor="review-done-action">Suggested action</label>
                        <select id="review-done-action" className="form-input" value={action}
                            onChange={e => setAction(e.target.value)}>
                            {REVIEW_ACTIONS.map(a => <option key={a.value} value={a.value}>{a.label}</option>)}
                        </select>
                    </div>
                    <div className="qa-field">
                        <label className="qa-field-label" htmlFor="review-done-comment">Comment (required)</label>
                        <div className="qa-quickfill">
                            <span className="qa-quickfill-cap">Quick fill:</span>
                            {CHIPS.map(c => (
                                <button key={c} type="button" className="qa-chip"
                                    onClick={() => setComment(c)}>{c}</button>
                            ))}
                        </div>
                        <textarea id="review-done-comment" className="form-input" rows={4}
                            value={comment} onChange={e => setComment(e.target.value)}
                            placeholder="What did you check or change?" />
                    </div>
                </div>
                <div className="modal-footer" style={{ padding: 'var(--space-4)' }}>
                    <button className="btn btn-secondary" onClick={onCancel}>Cancel</button>
                    <button className="btn btn-accent" disabled={busy || !trimmed}
                        onClick={() => onConfirm({ comment: trimmed, suggested_action: action })}>
                        {busy ? '…' : 'Review done'}
                    </button>
                </div>
            </div>
        </div>
    );
}
